export default "__VITE_ASSET__DBQkUhDu__"